import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import * as yup from 'yup';

export function useOrderConversionGatewaySchema() {
  const translate = useTypedTranslate();

  const deviationFieldSchema = yup
    .number()
    .typeError(translate('app.validation.enterNumber'))
    .required(translate('app.validation.required'))
    .positive(translate('app.validation.number.noNegative'))
    .min(10, translate('app.validation.number.greaterThan', { min: 10 }))
    .max(90, translate('app.validation.number.lessThan', { max: 90 }));

  const minOrdersCountSchema = yup
    .number()
    .typeError(translate('app.validation.enterNumber'))
    .required(translate('app.validation.required'))
    .min(0, translate('app.validation.number.greaterThan', { min: 0 }));

  return yup.object().shape({
    successDeviation: deviationFieldSchema,
    cancelDeviation: deviationFieldSchema,
    pendingDeviation: deviationFieldSchema,
    minOrdersCount: minOrdersCountSchema,
  });
}
